import { render, staticRenderFns } from "./FileSearch.vue?vue&type=template&id=23c5bddb&scoped=true&"
import script from "./FileSearch.vue?vue&type=script&lang=ts&"
export * from "./FileSearch.vue?vue&type=script&lang=ts&"
import style0 from "./FileSearch.vue?vue&type=style&index=0&id=23c5bddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5bddb",
  null
  
)

export default component.exports